import React from 'react';
import ReactDOM from 'react-dom/client';
import '@livekit/components-styles';
import './index.css';
import App from './App';
import { installUiScalePointerBridge } from './uiScale';

installUiScalePointerBridge();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
